import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { ThreeDots } from "react-loader-spinner";
import { toggleMenu } from "../../utils/helpers";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";
import "../../Styles/style.css";
import SortableTable from "../../components/SortableTable";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import { getApi } from "../../utils/api";
import Select from "react-select";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import axios from "axios";
import { designationOptions } from "../../options/designationOptions";
import CharLimitTextArea from "../../components/Performance/CharLimitTextArea";
import TeamMembersNotificationModal from "../../components/ProjectManagement/TeamMembersNotificationModal";
import { formatToDateOnly } from "../../utils/helpers";
import { displayFormatDate } from "../../utils/helpers";
import { MdKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import { projectTypeOptions } from "../../options/projectTypesOptions";
import {
  API_PROJECT,
  EMPLOYEE_LIST,
  API_ASSIGN_PROJECT_MEMBERS,
  API_EDIT_PROJECT_MEMBERS,
  API_DELETE_PROJECT_MEMBERS,
  API_LEAVE_GET_OOD_DL_LIST,
  API_EDIT_PROJECT_DETAILS,
  API_GET_PRINCIPAL_SPONSOR_LIST,
  API_GET_PROJECT_MANAGER_LIST,
  API_GET_LEAD_BUSINESS_ANALYST_LIST,
  API_PROJECT_COMPLETE_NOTIFICATION,
} from "../../config/Endpoints";
import ProjectListDetails from "../../components/ProjectManagement/ProjectListDetails";
import projectStatusOptions from "../../options/projectStatusOptions";
import ProjectCompleteNotificationModal from "../../components/ProjectManagement/ProjectCompletedNotificationModal";
import ProjectHoldToActiveModal from "../../components/ProjectManagement/ProjectHoldToActiveModal";

function ProjectList({ title, description }) {
  const [projectList, setProjectList] = useState([]);
  const [editingProjectId, setEditingProjectId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState(projectList);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [deliveryLead, setDeliveryLead] = useState([]);
  const [deleteTarget, setDeleteTarget] = useState({
    employeeId: null,
    projectId: null,
  });
  const [originalProjectData, setOriginalProjectData] = useState(null);
  const [originalMemberData, setOriginalMemberData] = useState(null);
  const [principalSponsors, setPrincipalSponsors] = useState([]);
  const [projectManagers, setProjectManagers] = useState([]);
  const [leadBusinessAnalysts, setLeadBusinessAnalysts] = useState([]);
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const [showDeallocateModal, setShowDeallocateModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [showConfirmDeallocateModal, setShowConfirmDeallocateModal] =
    useState(false);
  const [openProjectId, setOpenProjectId] = useState(null);
  const [editableStatus, setEditableStatus] = useState();
  const [showProjectCompletedModal, setShowProjectCompletedModal] =
    useState(false);
  const [pendingCompletedProjectId, setPendingCompletedProjectId] =
    useState(null);
  const [showHoldToActiveModal, setShowHoldToActiveModal] = useState(false);
  const [pendingHoldToActiveProjectId, setPendingHoldToActiveProjectId] =
    useState(null);
  const [holdToActiveDate, setHoldToActiveDate] = useState(null);
  const [holdToActiveLoading, setHoldToActiveLoading] = useState(false);
  // const toggleProject = (id) => {
  //   setOpenProjectId(openProjectId === id ? null : id);
  // };
  const toggleProject = (id) => {
    // If closing the currently open accordion
    if (openProjectId === id) {
      setOpenProjectId(null);
      // Reset edit mode for this project
      if (editingProjectId === id) {
        setEditingProjectId(null);
        setOriginalProjectData(null);
        const newEditableStatus = { ...editableStatus };
        delete newEditableStatus[id];
        setEditableStatus(newEditableStatus);
      }
    } else {
      // If opening a different accordion, close any open edit form
      if (editingProjectId && editingProjectId !== id) {
        // Restore original data if switching accordions
        if (originalProjectData) {
          const updateProject = (projects) =>
            projects.map((proj) =>
              proj.id === editingProjectId ? originalProjectData : proj
            );
          setProjectList((prev) => updateProject(prev));
          setFilteredItems((prev) => updateProject(prev));
        }
        setEditingProjectId(null);
        setOriginalProjectData(null);
      }
      setOpenProjectId(id);
    }
  };
  const [isLoadingCompletedProject, setIsLoadingCompletedProject] =
    useState(false);

  const dealocatedreasonOptions = [
    {
      value: "Project Delivery Completed",
      label: "Project Delivery Completed",
    },
    { value: "Change in Team Size", label: "Change in Team Size" },
    {
      value: "Transition to Managed Services",
      label: "Transition to Managed Services",
    },
    { value: "Resource Reshuffle", label: "Resource Reshuffle" },
  ];

  const hasProjectChanges = (currentProject, originalProject) => {
    if (!originalProject) return false;

    return (
      currentProject.projectType !== originalProject.projectType ||
      currentProject.dlId !== originalProject.dlId ||
      currentProject.startDate !== originalProject.startDate ||
      currentProject.endDate !== originalProject.endDate ||
      currentProject.sowStartDate !== originalProject.sowStartDate ||
      currentProject.sowEndDate !== originalProject.sowEndDate ||
      currentProject.commercialSummary !== originalProject.commercialSummary ||
      currentProject.projectManagerId !== originalProject.projectManagerId ||
      currentProject.principalSponsorId !==
        originalProject.principalSponsorId ||
      currentProject.leadBusinessAnalyst !==
        originalProject.leadBusinessAnalyst ||
      currentProject.projectStatus !== originalProject.projectStatus
    );
  };

  const hasMemberChanges = (currentMember, originalMember) => {
    if (!originalMember) return false;

    return (
      currentMember.designation !== originalMember.designation ||
      currentMember.joinDate !== originalMember.joinDate ||
      currentMember.endDate !== originalMember.endDate ||
      currentMember.status !== originalMember.status
    );
  };

  const handleProjectStatusUpdate = (projectId, projectStatus, pushStatus) => {
    const updateProject = (proj) => {
      if (proj.id !== projectId) return proj;

      const updates = {};

      if (projectStatus !== undefined) {
        updates.projectStatus = projectStatus;
      }

      if (pushStatus !== undefined) {
        updates.iscreatedPush = pushStatus;
      }

      if (projectStatus === 1 || projectStatus === 2) {
        updates.members = proj.members.map((member) => ({
          ...member,
          status: StatusEnum.DEALLOCATED,
        }));
      }

      return { ...proj, ...updates };
    };

    setProjectList((prev) => prev.map(updateProject));
    setFilteredItems((prev) => prev.map(updateProject));
  };

  const handleEditMember = (member, projectId) => {
    setCurrentProjectId(projectId);
    setEditingMemberId(member.id);
    console.log(member.id);
    setMemberForm({
      name: member.name,
      designation: member.designation,
      joinDate: member.joinDate,
      endDate: member.endDate,
      status: member.status,
      projectId: projectId,
    });
    setOriginalMemberData({
      name: member.name,
      designation: member.designation,
      joinDate: member.joinDate,
      endDate: member.endDate,
      status: member.status,
    });

    setSelectedEmployee({ value: member.id, label: member.name });
    setShowMemberModal(true);
  };

  const handleDateChange = (field, value) => {
    const updatedForm = {
      ...memberForm,
      [field]: value || null,
    };

    const project = projectList.find((p) => p.id === currentProjectId);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (updatedForm.status === StatusEnum.DEALLOCATED) {
      setMemberForm(updatedForm);
      return;
    }

    if (updatedForm.endDate) {
      const endDate = new Date(updatedForm.endDate);
      endDate.setHours(0, 0, 0, 0);
      if (endDate > currentDate) {
        updatedForm.status = StatusEnum.ACTIVE;
      } else {
        updatedForm.status = StatusEnum.INACTIVE;
      }
    } else if (updatedForm.joinDate) {
      updatedForm.status = StatusEnum.ACTIVE;
    } else {
      updatedForm.status = "";
    }

    setMemberForm(updatedForm);
  };

  const StatusEnum = {
    ACTIVE: 1,
    INACTIVE: 0,
    DEALLOCATED: 2,
  };

  const StatusOptions = [
    { value: StatusEnum.ACTIVE, label: "Active" },
    { value: StatusEnum.INACTIVE, label: "Inactive" },
    { value: StatusEnum.DEALLOCATED, label: "Deallocated" },
  ];

  const columns = (projectId) => [
    { key: "name", label: "Employee Name" },
    {
      key: "designation",
      label: "Designation",
      render: (item) => {
        const option = designationOptions.find(
          (opt) => opt.value === item.designation
        );
        return option ? option.label : "";
      },
    },
    {
      key: "joinDate",
      label: "Joining Date",
      compare: (a, b) => new Date(a.joinDate) - new Date(b.joinDate),
      render: (item) => {
        return displayFormatDate(item.joinDate);
      },
    },
    {
      key: "endDate",
      label: "End Date",
      compare: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      render: (item) => displayFormatDate(item.endDate),
    },
    {
      key: "status",
      label: "Status",
      render: (item) => {
        switch (item.status) {
          case 1:
            return "Active";
          case 0:
            return "Inactive";
          case 2:
            return "Deallocated";
          default:
            return item.status || "-";
        }
      },
    },
    {
      key: "action",
      label: "Action",
      render: (item) => {
        const project = projectList.find((p) => p.id === projectId);
        const isProjectCompleted = project?.projectStatus === 1;
        return (
          <div>
            <a
              href="javascript:void(0)"
              className={`fw-bolder ${
                isProjectCompleted || item.status === StatusEnum.DEALLOCATED
                  ? "text-muted"
                  : ""
              }`}
              onClick={() => {
                if (
                  !isProjectCompleted &&
                  item.status !== StatusEnum.DEALLOCATED
                ) {
                  handleEditMember(item, projectId);
                }
              }}
              style={{
                cursor:
                  isProjectCompleted || item.status === StatusEnum.DEALLOCATED
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Edit
            </a>

            <a
              href="javascript:void(0)"
              className="ms-3 fw-bolder text-danger"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdropDependentDelete"
              onClick={() =>
                setDeleteTarget({ employeeId: item.employeeId, projectId })
              }
              style={{ cursor: "pointer" }}
            >
              Delete
            </a>
          </div>
        );
      },

      sortable: false,
    },
  ];
  const [showMemberModal, setShowMemberModal] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);

  const [memberForm, setMemberForm] = useState({
    name: "",
    designation: "",
    joinDate: null,
    endDate: null,
    status: "",
  });
  const [editingMemberId, setEditingMemberId] = useState(null);

  const handleSearch = (e) => {
    const searchValue = e.target.value;

    setSearchTerm(searchValue);
    const filtered = projectList.filter((item) =>
      item.projectName.toLowerCase().includes(searchValue.toLowerCase())
    );

    setFilteredItems(filtered);
  };

  const handleProjectChange = (projectId, field, value, name) => {
    const updateProject = (projects) =>
      projects.map((proj) =>
        proj.id === projectId
          ? {
              ...proj,
              [field]: value instanceof Date ? formatToDateOnly(value) : value,
              ...(field === "dlId" && { dlName: name }),
              ...(field === "projectManagerId" && { projectManagerName: name }),
              ...(field === "principalSponsorId" && {
                principalSponsorName: name,
              }),
              ...(field === "leadBusinessAnalyst" && {
                leadBusinessAnalystName: name,
              }),
            }
          : proj
      );
    setProjectList((prev) => updateProject(prev));
    setFilteredItems((prev) => updateProject(prev));
  };

  const handleUpdateProject = async (
    projectId,
    e = null,
    sendNotification = false,
    withHoldToActiveDate = false,
    holdToActiveDate = null
  ) => {
    if (e) e.preventDefault();

    const project = projectList.find((p) => p.id === projectId);
    const originalStatus = project.projectStatus;

    const isChangingToComplete =
      originalProjectData?.projectStatus === 2 && project.projectStatus === 1;

    const isChangingToActive =
      originalProjectData?.projectStatus === 2 && project.projectStatus === 0;

    if (isChangingToActive && !withHoldToActiveDate) {
      setPendingHoldToActiveProjectId(projectId);
      setShowHoldToActiveModal(true);
      return;
    }

    if (isChangingToComplete && !sendNotification) {
      setPendingCompletedProjectId(projectId);
      setShowProjectCompletedModal(true);
      return;
    }

    if (sendNotification) {
      setIsLoadingCompletedProject(true);
    } else if (withHoldToActiveDate) {
      setHoldToActiveLoading(true);
    } else {
      setIsLoadingUpdate(true);
    }

    const toDate = (d) => {
      if (!d) return null;
      const x = new Date(d);
      x.setHours(0, 0, 0, 0);
      return x;
    };

    const payload = {
      projectName: project.projectName,
      projectType: project.projectType,
      status: project.projectStatus,
      deliveryLead: project.dlId,
      startDate: formatToDateOnly(toDate(project.startDate)),
      endDate: formatToDateOnly(toDate(project.endDate)),
      sowStartDate: formatToDateOnly(toDate(project.sowStartDate)),
      sowEndDate: formatToDateOnly(toDate(project.sowEndDate)),
      commercialSummary: project.commercialSummary,
      projectManager: project.projectManagerId,
      principalSponsor: project.principalSponsorId,
      leadBusinessAnalyst: project.leadBusinessAnalyst || null,
      holdToActiveDate:
        holdToActiveDate && !isNaN(new Date(holdToActiveDate))
          ? formatToDateOnly(new Date(holdToActiveDate))
          : null,
    };

    try {
      const res = await axios.patch(
        `${API_EDIT_PROJECT_DETAILS}/${projectId}`,
        payload,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (res.status === 200) {
        if (sendNotification) {
          try {
            const notifyRes = await axios.post(
              `${API_PROJECT_COMPLETE_NOTIFICATION}/${projectId}`,
              {},
              { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            if (notifyRes.status === 200) {
              const completePayload = { ...payload, status: 1 };
              await axios.patch(
                `${API_EDIT_PROJECT_DETAILS}/${projectId}`,
                completePayload,
                { headers: { Authorization: `Bearer ${accessToken}` } }
              );

              toast.success(
                "Project completed and notification sent successfully."
              );
            } else {
              throw new Error(notifyRes.data.message || "Notification failed");
            }
          } catch (notifyErr) {
            await axios.patch(
              `${API_EDIT_PROJECT_DETAILS}/${projectId}`,
              { ...payload, status: 2 },
              { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            toast.error(notifyErr?.message || "Error ");
            return;
          }
        } else {
          toast.success("Project updated successfully.");
        }

        setOriginalProjectData(null);
        setEditingProjectId(null);
        const newEditableStatus = { ...editableStatus };
        delete newEditableStatus[projectId];
        setEditableStatus(newEditableStatus);

        await fetchProjects();
        if (searchTerm) {
          setSearchTerm("");
        }
        setShowProjectCompletedModal(false);
        setPendingCompletedProjectId(null);
      } else {
        toast.error(res?.data?.message || "Failed to update project");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Action failed");
    } finally {
      setIsLoadingCompletedProject(false);
      setIsLoadingUpdate(false);
      setHoldToActiveLoading(false);
    }
  };

  const handleCompleteConfirm = async () => {
    await handleUpdateProject(pendingCompletedProjectId, null, true);
  };

  const handleCompleteCancel = () => {
    if (originalProjectData && pendingCompletedProjectId) {
      const updateProject = (projects) =>
        projects.map((proj) =>
          proj.id === pendingCompletedProjectId
            ? { ...proj, projectStatus: originalProjectData.projectStatus }
            : proj
        );

      setProjectList((prev) => updateProject(prev));
      setFilteredItems((prev) => updateProject(prev));
    }

    setShowProjectCompletedModal(false);
    setPendingCompletedProjectId(null);
  };

  const handleHoldToActiveConfirm = async (date) => {
    await handleUpdateProject(
      pendingHoldToActiveProjectId,
      null,
      false,
      true,
      date
    );
    setShowHoldToActiveModal(false);
    setPendingHoldToActiveProjectId(null);
    setHoldToActiveDate(null);
  };

  const handleHoldToActiveCancel = () => {
    if (originalProjectData && pendingHoldToActiveProjectId) {
      const updateProject = (projects) =>
        projects.map((proj) =>
          proj.id === setPendingHoldToActiveProjectId
            ? { ...proj, projectStatus: originalProjectData.projectStatus }
            : proj
        );

      setProjectList((prev) => updateProject(prev));
      setFilteredItems((prev) => updateProject(prev));
    }

    setShowHoldToActiveModal(false);
    setPendingHoldToActiveProjectId(null);
    setHoldToActiveDate(null);
  };

  const handleDelete = async () => {
    if (!deleteTarget.employeeId || !deleteTarget.projectId) return;

    try {
      setIsLoadingDelete(true);

      const res = await axios.delete(
        `${API_DELETE_PROJECT_MEMBERS}/${deleteTarget.employeeId}/${deleteTarget.projectId}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      toast.success(res?.data?.message || "Member deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });

      const updateProjects = (projects) =>
        projects.map((proj) =>
          proj.id === deleteTarget.projectId
            ? {
                ...proj,
                members: proj.members.filter(
                  (member) => member.employeeId !== deleteTarget.employeeId
                ),
              }
            : proj
        );

      setProjectList((prev) => updateProjects(prev));
      setFilteredItems((prev) => updateProjects(prev));

      // Modal close
      const modal = document.getElementById("staticBackdropDependentDelete");
      if (modal) {
        const bsModal = window.bootstrap.Modal.getInstance(modal);
        bsModal?.hide();
      }

      setDeleteTarget({ employeeId: null, projectId: null });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete member", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoadingDelete(false);
    }
  };

  const openMemberModal = (projectId, memberId = null) => {
    document.body.classList.add("modal-open");
    setCurrentProjectId(projectId);
    setEditingMemberId(memberId);

    if (memberId) {
      const project = projectList.find((p) => p.id === projectId);
      const member = project?.members.find((m) => m.id === memberId);
      if (member) {
        setMemberForm({
          id: member.id,
          name: member.name,
          designation: member.designation,
          joinDate: member.createdDate ? member.createdDate : "",
        });
      }
    } else {
      setMemberForm({
        name: "",
        designation: "",
        joinDate: "",
      });
    }
    setShowMemberModal(true);
  };

  const closeMemberModal = () => {
    document.body.classList.remove("modal-open");

    setShowMemberModal(false);
    setCurrentProjectId(null);
    setEditingMemberId(null);
    setMemberForm({
      name: "",
      designation: "",
      joinDate: "",
    });
    setSelectedEmployee(null);
    setOriginalMemberData(null);
  };

  const fetchProjects = async () => {
    try {
      setIsLoading(true);
      const response = await getApi(API_PROJECT, accessToken);
      const projects = (response.data?.data || []).map((p) => ({
        id: p.projectId,
        projectName: p.projectName || "Untitled Project",
        projectType: p.projectType,
        startDate: p.startDate,
        endDate: p.endDate,
        sowStartDate: p.sowStartDate,
        sowEndDate: p.sowEndDate,
        commercialSummary: p.commercialSummary || "No description available",
        dlId: p.dlId,
        dlName: p.dlName,
        projectManagerName: p.projectManagerName,
        principalSponsorName: p.principalSponsorName,
        projectManagerId: p.projectManagerId,
        principalSponsorId: p.principalSponsorId,
        leadBusinessAnalyst: p.leadBusinessAnalyst,
        leadBusinessAnalystName: p.leadBusinessAnalystName,
        iscreatedPush: p.iscreatedPush,
        projectStatus: p.status,
        members: (p.members || []).map((m) => ({
          id: m.id,
          name: `${m.fullName}`,
          designation: m.designation,
          joinDate: m.createdDate,
          employeeId: m.employeeId,
          endDate: m.endDate,
          status: m.status,
        })),
      }));
      setProjectList(projects);
      setFilteredItems(projects);
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await getApi(EMPLOYEE_LIST, accessToken);
      const users = res.data?.data || [];

      const options = users.map((u) => ({
        value: u.id,
        label: u.empName,
      }));
      setEmployeeList(options);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };
  useEffect(() => {
    const fetchDeliveryLeads = async () => {
      try {
        const response = await getApi(API_LEAVE_GET_OOD_DL_LIST, accessToken);
        const leads = (
          Array.isArray(response.data)
            ? response.data
            : response.data?.data || []
        ).map((emp) => ({
          value: Number(emp.id),
          label: emp.fullName || "",
        }));
        setDeliveryLead(leads);
      } catch (error) {
        console.error("Error fetching delivery leads:", error);
        setDeliveryLead([]);
      }
    };

    fetchDeliveryLeads();
  }, []);

  useEffect(() => {
    const fetchProjectManagers = async () => {
      try {
        const response = await getApi(
          API_GET_PROJECT_MANAGER_LIST,
          accessToken
        );
        const managers = (response.data?.data || []).map((pm) => ({
          value: Number(pm.id),
          label: `${pm.firstName} ${pm.lastName}` || "Unnamed Manager",
        }));
        setProjectManagers(managers);
      } catch (error) {
        console.error("Error fetching project managers:", error);
        setProjectManagers([]);
      }
    };
    fetchProjectManagers();
  }, []);

  useEffect(() => {
    const fetchPrincipalSponsors = async () => {
      try {
        const response = await getApi(
          API_GET_PRINCIPAL_SPONSOR_LIST,
          accessToken
        );
        const sponsors = (response.data?.data || []).map((sponsor) => ({
          value: sponsor.id,
          label:
            `${sponsor.firstName} ${sponsor.lastName}` || "Unnamed Sponsor",
        }));
        setPrincipalSponsors(sponsors);
      } catch (error) {
        console.error("Error fetching principal sponsors:", error);
        setPrincipalSponsors([]);
      }
    };
    fetchPrincipalSponsors();
  }, []);

  useEffect(() => {
    const fetchLBA = async () => {
      try {
        const response = await getApi(
          API_GET_LEAD_BUSINESS_ANALYST_LIST,
          accessToken
        );
        const lbas = (response.data?.data || []).map((lba) => ({
          value: lba.id,
          label: `${lba.firstName} ${lba.lastName}`,
        }));
        setLeadBusinessAnalysts(lbas);
      } catch (error) {
        console.error("Error fetching LBAs:", error);
        setLeadBusinessAnalysts([]);
      }
    };
    fetchLBA();
  }, []);

  useEffect(() => {
    fetchProjects();
    fetchEmployees();
  }, []);

  const isValidDate = (d) => d instanceof Date && !isNaN(d.getTime());

  const addMember = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);

      const project = projectList.find((p) => p.id === currentProjectId);

      if (
        memberForm.designation === "PROJECT_MANAGER" &&
        project?.projectManagerId === selectedEmployee.value
      ) {
        toast.error("This Project Manager is already assigned!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      const joinDate = memberForm.joinDate
        ? new Date(memberForm.joinDate)
        : null;
      const endDate = memberForm.endDate ? new Date(memberForm.endDate) : null;

      if (joinDate && endDate) {
        if (endDate < joinDate) {
          toast.error("End date must be after joining date!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
      }

      const payload = {
        projectId: currentProjectId,
        employeeId: selectedEmployee.value,
        designation: memberForm.designation,
        createdBy: userData.id,
        createdAt: isValidDate(joinDate) ? toUTCDateString(joinDate) : null,
        endDate: isValidDate(endDate) ? toUTCDateString(endDate) : null,
        status: memberForm.status,
      };

      const res = await axios({
        method: "post",
        url: API_ASSIGN_PROJECT_MEMBERS,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
      });

      const newMember = {
        id: res.data?.data?.id,
        name: selectedEmployee.label,
        designation: memberForm.designation,
        joinDate: memberForm.joinDate,
        endDate: memberForm.endDate,
        employeeId: selectedEmployee.value,
        status: memberForm.status,
      };

      // Update both projectList and filteredItems
      const updateProjects = (projects) =>
        projects.map((proj) =>
          proj.id === currentProjectId
            ? { ...proj, members: [...proj.members, newMember] }
            : proj
        );

      setProjectList((prev) => updateProjects(prev));
      setFilteredItems((prev) => updateProjects(prev));

      toast.success(res?.data?.message || "Member assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });

      closeMemberModal();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const toUTCDateString = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00:00`;
  };

  const updateMember = async (memberData = null, isDeallocating = false) => {
    try {
      setIsLoading(true);

      const formData = memberData || memberForm;

      if (!formData.designation) {
        toast.error("Designation is required!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      const joinDate = formData.joinDate ? new Date(formData.joinDate) : null;
      const endDate = formData.endDate ? new Date(formData.endDate) : null;
      if (!isDeallocating && joinDate && endDate) {
        if (endDate < joinDate) {
          toast.error("End date must be after joining date!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
      }

      const payload = {
        name: formData.name,
        designation: formData.designation,
        createdAt: formData.joinDate
          ? toUTCDateString(formData.joinDate)
          : null,
        endDate: formData.endDate ? toUTCDateString(formData.endDate) : null,
        status: formData.status,
        projectId: formData.projectId || currentProjectId,
        reason: "",
      };

      if (formData.status === StatusEnum.DEALLOCATED && formData.reason) {
        payload.reason = formData.reason;
      }

      const res = await axios({
        method: "put",
        url: `${API_EDIT_PROJECT_MEMBERS}/${editingMemberId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: payload,
      });

      await fetchProjects();
      setSearchTerm("");
      const message =
        formData.status === StatusEnum.DEALLOCATED
          ? "Member Deallocated Successfully."
          : "Member Updated Successfully.";

      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (!memberData) {
        closeMemberModal();
      }

      return res;
    } catch (err) {
      console.error("Update member error:", err);

      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to update member. Please try again.";

      toast.error(errorMessage, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const saveMember = async (e) => {
    e.preventDefault();

    if (editingMemberId) {
      await updateMember();
    } else {
      await addMember(e);
    }
  };

  const handleDeallocateConfirm = async () => {
    setIsLoading(true);
    try {
      const updatedMemberForm = {
        ...memberForm,
        status: StatusEnum.DEALLOCATED,
        reason: selectedReason?.value,
      };

      const endDate = new Date(memberForm.endDate);
      const today = new Date();

      if (endDate > today) {
        toast.error("End date must be on or before the current date.");
        setIsLoading(false);
        return;
      }

      await updateMember(updatedMemberForm, true);

      setShowConfirmDeallocateModal(false);
      setShowDeallocateModal(false);
      closeMemberModal();
    } catch (error) {
      console.error("Deallocation failed", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper-body">
      {/* Page Heading */}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Projects :{" "}
          <span>{searchTerm ? filteredItems.length : projectList.length}</span>
        </div>
      </div>

      {/* Filters */}
      <div className="filters">
        <div className="search">
          <input
            type="text"
            name="search"
            placeholder="Search By Project Name"
            value={searchTerm}
            onChange={handleSearch}
            required
          />
          <img src="/assets/images/search-ico.svg" width="14" alt="Search" />
        </div>
        <Link className="btn theme-button" to="/dashboard/createProject">
          Create Project
        </Link>
        <div className="actions"></div>
      </div>

      {isLoading && (
        <div className="centered-loader">
          <ThreeDots
            height="100"
            width="100"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      {!isLoading && (
        <div className="accordion" id="accordionProjects">
          {filteredItems.length === 0 ? (
            <p className="fs-4 m-5 text-secondary text-center">
              No Records Available
            </p>
          ) : (
            filteredItems.map((project) => (
              <div
                className="accordion-item project-accordion-item"
                key={`${project.id}-${project.projectStatus}`}
              >
                <h2
                  className="accordion-header"
                  id={`heading-${project.id}`}
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",
                  }}
                >
                  <button
                    className={`accordion-button ${
                      openProjectId === project.id ? "" : "collapsed"
                    }`}
                    type="button"
                    onClick={() => toggleProject(project.id)}
                  >
                    <span>{project.projectName}</span>

                    <span
                      className={`project-status-badge ${
                        project.projectStatus === 1
                          ? "badge-complete"
                          : project.projectStatus === 2
                          ? "badge-onhold"
                          : "badge-active"
                      }`}
                    >
                      {project.projectStatus === 1
                        ? "Completed"
                        : project.projectStatus === 2
                        ? "On Hold"
                        : "Active"}
                    </span>

                    {openProjectId === project.id ? (
                      <MdOutlineKeyboardArrowUp className="dropdown-icon" />
                    ) : (
                      <MdKeyboardArrowDown className="dropdown-icon" />
                    )}
                  </button>
                </h2>
                <div
                  id={`collapse-${project.id}`}
                  className={`accordion-collapse collapse ${
                    openProjectId === project.id ? "show" : ""
                  }`}
                  aria-labelledby={`heading-${project.id}`}
                  data-bs-parent="#accordionProjects"
                >
                  <div className="accordion-body p-4">
                    <div className="row">
                      <div className="col-md-10"></div>
                      <div className="col-md-2">
                        {editingProjectId !== project.id &&
                          project.projectStatus !== 1 && (
                            <a
                              style={{
                                float: "right",
                                fontSize: "18px",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOriginalProjectData({ ...project });
                                setEditingProjectId(project.id);
                                setEditableStatus({
                                  ...editableStatus,
                                  [project.id]: project.projectStatus,
                                });
                              }}
                            >
                              <i class="fa fa-edit"></i>
                            </a>
                          )}
                      </div>
                    </div>
                    {editingProjectId !== project.id && (
                      <>
                        <ProjectListDetails project={project} />

                        <div className="col-md-12 mt-4">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5
                              className="mb-0"
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                borderBottom: "none",
                                borderRadius: "2px",
                                padding: "2px 10px",
                                backgroundColor: "white",
                              }}
                            >
                              Team Members
                            </h5>
                            {project.projectStatus !== 1 && (
                              <div className="d-flex gap-2">
                                <TeamMembersNotificationModal
                                  projectId={project.id}
                                  iscreatedPush={project.iscreatedPush}
                                  onStatusUpdate={handleProjectStatusUpdate}
                                  disabled={project.projectStatus === 2}
                                  project={project}
                                />

                                <button
                                  className="btn theme-button"
                                  onClick={() => openMemberModal(project.id)}
                                  disabled={project.projectStatus === 2}
                                >
                                  Add Member
                                </button>
                              </div>
                            )}
                          </div>
                          {project.members && project.members.length > 0 ? (
                            <SortableTable
                              columns={columns(project.id)}
                              data={project.members}
                            />
                          ) : (
                            <NoRecordsAvailable />
                          )}
                        </div>
                      </>
                    )}
                    {editingProjectId === project.id && (
                      <form
                        onSubmit={(e) => handleUpdateProject(project.id, e)}
                      >
                        <div className="row mb-2 ">
                          <div className="col-md-6 px-4 mt-2 project-details">
                            {/* Project Name */}
                            <div className="row p-2 mt-2 align-items-center ">
                              <label className="col-md-5 text-black-50">
                                Project Name
                              </label>
                              <div className="col-md-7 p-3 project-details-field">
                                {project.projectName}
                              </div>
                            </div>
                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Project Type
                              </label>
                              <div className="col-md-7 p-0  ">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  options={projectTypeOptions}
                                  value={
                                    project.projectType
                                      ? projectTypeOptions.find(
                                          (type) =>
                                            type.value === project.projectType
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    const value = selected
                                      ? selected.value
                                      : null;
                                    const label = selected
                                      ? selected.label
                                      : null;

                                    handleProjectChange(
                                      project.id,
                                      "projectType",
                                      value,
                                      label
                                    );
                                  }}
                                  placeholder="Select Project Type"
                                />
                              </div>
                            </div>
                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Delivery Lead
                              </label>
                              <div className="col-md-7 p-0  ">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  options={deliveryLead}
                                  value={
                                    project.dlId
                                      ? deliveryLead.find(
                                          (lead) => lead.value === project.dlId
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    const value = selected
                                      ? selected.value
                                      : null;
                                    const label = selected
                                      ? selected.label
                                      : null;

                                    handleProjectChange(
                                      project.id,
                                      "dlId",
                                      value,
                                      label
                                    );
                                  }}
                                  placeholder="Select the Delivery Lead"
                                />
                              </div>
                            </div>

                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Project Manager
                              </label>
                              <div className="col-md-7 p-0  ">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Project Manager"
                                  options={projectManagers}
                                  value={
                                    project.projectManagerId
                                      ? projectManagers.find(
                                          (emp) =>
                                            emp.value ===
                                            project.projectManagerId
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    handleProjectChange(
                                      project.id,
                                      "projectManagerId",
                                      selected ? selected.value : null,
                                      selected ? selected.label : null
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Principal Sponsor
                              </label>
                              <div className="col-md-7 p-0  ">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Principal Sponsor"
                                  options={principalSponsors}
                                  value={
                                    project.principalSponsorId
                                      ? principalSponsors.find(
                                          (emp) =>
                                            emp.value ===
                                            project.principalSponsorId
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    const value = selected
                                      ? selected.value
                                      : null;
                                    const label = selected
                                      ? selected.label
                                      : null;

                                    handleProjectChange(
                                      project.id,
                                      "principalSponsorId",
                                      value,
                                      label
                                    );
                                  }}
                                />
                              </div>
                            </div>

                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Lead Business Analyst
                              </label>
                              <div className="col-md-7 p-0">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Lead Business Analyst"
                                  options={leadBusinessAnalysts}
                                  value={
                                    project.leadBusinessAnalyst
                                      ? leadBusinessAnalysts.find(
                                          (emp) =>
                                            emp.value ===
                                            project.leadBusinessAnalyst
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    handleProjectChange(
                                      project.id,
                                      "leadBusinessAnalyst",
                                      selected ? selected.value : null,
                                      selected ? selected.label : null
                                    );
                                  }}
                                  isClearable={true}
                                />
                              </div>
                            </div>

                            {editableStatus[project.id] === 2 && (
                              <div
                                className="row p-2 mt-2 align-items-center"
                                style={{ zIndex: 200 }}
                              >
                                <label className="col-md-5 text-black-50">
                                  Project Status
                                </label>
                                <div className="col-md-7 p-0">
                                  <Select
                                    className="custom-select custom-edit-select"
                                    classNamePrefix="react-select"
                                    options={projectStatusOptions}
                                    value={
                                      project.projectStatus !== null &&
                                      project.projectStatus !== undefined
                                        ? projectStatusOptions.find(
                                            (type) =>
                                              type.value ===
                                              project.projectStatus
                                          )
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const value = selected
                                        ? selected.value
                                        : null;
                                      const label = selected
                                        ? selected.label
                                        : null;

                                      handleProjectChange(
                                        project.id,
                                        "projectStatus",
                                        value,
                                        label
                                      );
                                    }}
                                    placeholder="Select Project Status"
                                  />
                                </div>
                              </div>
                            )}

                            <div className="row p-2 mt-2 align-items-center justify-content-between">
                              <label className="col-md-5 text-black-50 mb-2">
                                SOW
                              </label>
                              <div className="col-md-7 d-flex justify-content-between p-0 gap-3">
                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    Start Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "sowStartDate",
                                        date ? format(date, "MM-dd-yyyy") : ""
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="custom-date custom-edit-project-date py-3 px-2 text-center w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                    required
                                  />
                                </div>

                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    End Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "sowEndDate",
                                        date ? format(date, "MM-dd-yyyy") : ""
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    minDate={project.sowStartDate}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="py-3 px-2 text-center custom-date custom-edit-project-date w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row justify-content-between p-2 mt-2 align-items-center">
                              <label className="col-md-5 text-black-50 mb-2">
                                Actual
                              </label>
                              <div className="col-md-7 d-flex justify-content-between p-0 gap-3">
                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    Start Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.startDate
                                        ? new Date(project.startDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "startDate",
                                        date ? format(date, "MM-dd-yyyy") : ""
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="custom-date custom-edit-project-date py-3 px-2 text-center w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                  />
                                </div>

                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    End Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.endDate
                                        ? new Date(project.endDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "endDate",
                                        date ? format(date, "MM-dd-yyyy") : ""
                                      )
                                    }
                                    minDate={
                                      project.startDate
                                        ? new Date(project.startDate)
                                        : null
                                    }
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="custom-date custom-edit-project-date py-3 px-2 text-center w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 px-4 mt-3 project-details">
                            <div>
                              <label className=" mb-2 py-2 mt-3 text-black-50">
                                Project Description
                              </label>
                              <div className="input-group">
                                <CharLimitTextArea
                                  id="commercialSummary"
                                  name="commercialSummary"
                                  required
                                  rows={16}
                                  placeholder="Type Here"
                                  maxLength={1500}
                                  value={project.commercialSummary}
                                  onChange={(e) =>
                                    handleProjectChange(
                                      project.id,
                                      "commercialSummary",
                                      e.target.value
                                    )
                                  }
                                  lengthParam={
                                    project.commercialSummary?.length || 0
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Buttons */}
                        <div className="row mt-3">
                          <div className="col-md-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary btn-md"
                              disabled={
                                isLoadingUpdate ||
                                !hasProjectChanges(project, originalProjectData)
                              }
                            >
                              {isLoadingUpdate ? (
                                <ThreeDots
                                  height="25"
                                  width="80"
                                  radius="9"
                                  color="white"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClassName=""
                                  visible={true}
                                />
                              ) : (
                                "Update"
                              )}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary btn-md ms-2"
                              onClick={() => {
                                if (originalProjectData) {
                                  const updateProject = (projects) =>
                                    projects.map((proj) =>
                                      proj.id === originalProjectData.id
                                        ? originalProjectData
                                        : proj
                                    );

                                  setProjectList((prev) => updateProject(prev));
                                  setFilteredItems((prev) =>
                                    updateProject(prev)
                                  );
                                }

                                setEditingProjectId(null);
                                setOriginalProjectData(null);
                              }}
                            >
                              &nbsp; Close &nbsp;
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {showMemberModal &&
        (() => {
          const project = projectList.find((p) => p.id === currentProjectId);
          if (editingMemberId) {
            return (
              <div
                className="modal show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content rounded-lg">
                    {/* Header */}
                    <div className="modal-header ">
                      <h5 className="modal-title">Edit Team Member</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={closeMemberModal}
                        style={{ filter: "invert(0.3)" }}
                      ></button>
                    </div>

                    <form onSubmit={saveMember}>
                      <div
                        className="modal-body py-5 px-4"
                        style={{ backgroundColor: "#fafbff" }}
                      >
                        <div className="container-fluid">
                          <div className="row justify-content-center">
                            <div className="col-md-10">
                              {/* Full Name Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Employee Name
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={employeeList}
                                    value={selectedEmployee}
                                    isDisabled
                                    placeholder="Select Employee"
                                  />
                                </div>
                              </div>

                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Designation
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder="Select Designation"
                                    options={designationOptions}
                                    value={
                                      memberForm.designation
                                        ? designationOptions.find(
                                            (opt) =>
                                              opt.value ===
                                              memberForm.designation
                                          )
                                        : null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        designation: option.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              {/* Join Date Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Joining Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : null
                                    }
                                    minDate={
                                      project?.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    maxDate={
                                      project?.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleDateChange("joinDate", date)
                                    }
                                    required
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* End Date */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    End Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.endDate
                                        ? new Date(memberForm.endDate)
                                        : null
                                    }
                                    minDate={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : project?.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    maxDate={
                                      project?.endDate
                                        ? new Date(project.endDate)
                                        : project?.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(date) =>
                                      handleDateChange("endDate", date)
                                    }
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Status Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Status
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={StatusOptions}
                                    value={
                                      StatusOptions.find(
                                        (opt) => opt.value === memberForm.status
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        status: option.value,
                                      })
                                    }
                                    placeholder="Select Status"
                                    isDisabled={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer */}
                      <div
                        className="modal-footer rounded-lg-bottom"
                        style={{
                          backgroundColor: "#f8f9ff",
                          borderTop: "1px solid #e1e5f7",
                        }}
                      >
                        <button
                          type="button"
                          className="btn px-4 py-2"
                          onClick={closeMemberModal}
                          style={{
                            backgroundColor: "#6c757d",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn theme-button"
                          disabled={
                            (isLoading && !showConfirmDeallocateModal) ||
                            !hasMemberChanges(memberForm, originalMemberData)
                          }
                        >
                          {isLoading && !showConfirmDeallocateModal ? (
                            <ThreeDots
                              height="25"
                              width="80"
                              radius="9"
                              color="white"
                              ariaLabel="three-dots-loading"
                              visible={true}
                            />
                          ) : (
                            "Save Changes"
                          )}
                        </button>
                        <button
                          type="button"
                          className="btn px-4 py-2"
                          onClick={() => {
                            setIsLoading(false);
                            setSelectedReason(null);
                            setShowDeallocateModal(true);
                          }}
                          style={{
                            backgroundColor: "#d63737ff",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                          }}
                          disabled={!memberForm.endDate}
                        >
                          Deallocate
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            );
          } else {
            // --- Add Modal Code ---
            return (
              <div
                className="modal show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content rounded-lg">
                    {/* Header */}
                    <div className="modal-header">
                      <h5 className="modal-title">Add New Member</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={closeMemberModal}
                        style={{ filter: "invert(0.3)" }}
                      ></button>
                    </div>

                    <form onSubmit={saveMember}>
                      <div
                        className="modal-body py-5 px-4"
                        style={{ backgroundColor: "#fafbff" }}
                      >
                        <div className="container-fluid">
                          <div className="row justify-content-center">
                            <div className="col-md-10">
                              {/* Full Name Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end has-asterisk">
                                    Employee Name
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={employeeList}
                                    value={selectedEmployee}
                                    onChange={(option) => {
                                      setSelectedEmployee(option);
                                      setMemberForm({
                                        ...memberForm,
                                        name: option ? option.label : "",
                                      });
                                    }}
                                    placeholder="Select Employee"
                                    isSearchable
                                    isClearable
                                    required
                                  />
                                </div>
                              </div>

                              {/* Role Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end has-asterisk">
                                    Designation
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder="Select Designation"
                                    options={designationOptions}
                                    value={
                                      memberForm.designation
                                        ? designationOptions.find(
                                            (opt) =>
                                              opt.value ===
                                              memberForm.designation
                                          )
                                        : null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        designation: option ? option.value : "",
                                      })
                                    }
                                    required
                                    isClearable
                                  />
                                </div>
                              </div>

                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end has-asterisk">
                                    Joining Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : null
                                    }
                                    minDate={
                                      project?.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    maxDate={
                                      project?.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleDateChange(
                                        "joinDate",
                                        date ? format(date, "MM-dd-yyyy") : ""
                                      )
                                    }
                                    required
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* End Date */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end">
                                    End Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.endDate
                                        ? new Date(memberForm.endDate)
                                        : null
                                    }
                                    minDate={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : project?.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    maxDate={
                                      project?.endDate
                                        ? new Date(project.endDate)
                                        : project?.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(date) =>
                                      handleDateChange(
                                        "endDate",
                                        date ? format(date, "MM-dd-yyyy") : ""
                                      )
                                    }
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Status Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end">
                                    Status
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={StatusOptions}
                                    value={
                                      StatusOptions.find(
                                        (opt) => opt.value === memberForm.status
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        status: option.value,
                                      })
                                    }
                                    placeholder="Select Status"
                                    isDisabled={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer */}
                      <div
                        className="modal-footer rounded-lg-bottom"
                        style={{
                          backgroundColor: "#f8f9ff",
                          borderTop: "1px solid #e1e5f7",
                        }}
                      >
                        <button
                          type="button"
                          className="btn px-4 py-2"
                          onClick={closeMemberModal}
                          style={{
                            backgroundColor: "#6c757d",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn theme-button"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <ThreeDots
                              height="25"
                              width="80"
                              radius="9"
                              color="white"
                              ariaLabel="three-dots-loading"
                              visible={true}
                            />
                          ) : (
                            "Add Member"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            );
          }
        })()}

      {/* Footer */}
      {/* Delete Confirmation Modal */}
      <div
        className="modal fade"
        id="staticBackdropDependentDelete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content rounded-lg">
            <div className="modal-body">
              <h5 className="text-center">
                Are you sure you want to delete this member?
              </h5>
            </div>
            <div className="justify-content-center modal-footer">
              <button
                type="button"
                className={
                  isLoadingDelete ? "theme-button disabled" : "theme-button"
                }
                onClick={handleDelete}
              >
                {isLoadingDelete ? (
                  <ThreeDots
                    height="20"
                    width="53"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                ) : (
                  "Yes"
                )}
              </button>
              <button
                type="button"
                className="theme-button bg-grey mx-3 w-35"
                data-bs-dismiss="modal"
                onClick={() =>
                  setDeleteTarget({ employeeId: null, projectId: null })
                }
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Deallocation Modal */}
      {showDeallocateModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content rounded-lg">
              <div className="modal-header">
                <h5 className="modal-title">Deallocate Member</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDeallocateModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Reason for Deallocation</label>
                <Select
                  options={dealocatedreasonOptions}
                  value={selectedReason}
                  onChange={(option) => setSelectedReason(option)}
                  placeholder="Select Reason"
                  disabled={!selectedReason}
                />
              </div>
              <div className="modal-footer rounded-lg-bottom">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDeallocateModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn theme-button"
                  onClick={() => {
                    if (selectedReason) {
                      setShowDeallocateModal(false);
                      setShowConfirmDeallocateModal(true);
                    }
                  }}
                  disabled={!selectedReason}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Deallocation Confirmation Modal */}

      {showConfirmDeallocateModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content rounded-lg">
              <div className="modal-body">
                <h5 className="text-center">
                  Are you sure you want to deallocate this member?
                </h5>
              </div>
              <div className="modal-footer justify-content-center rounded-lg-bottom">
                <button
                  type="button"
                  className={
                    isLoading && showConfirmDeallocateModal
                      ? "theme-button disabled"
                      : "theme-button"
                  }
                  onClick={handleDeallocateConfirm}
                >
                  {isLoading ? (
                    <ThreeDots
                      height="20"
                      width="53"
                      radius="9"
                      color="white"
                      ariaLabel="three-dots-loading"
                      visible={true}
                    />
                  ) : (
                    "Yes"
                  )}
                </button>
                <button
                  type="button"
                  className="theme-button bg-grey mx-3 w-35"
                  onClick={() => setShowConfirmDeallocateModal(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <ProjectCompleteNotificationModal
        show={showProjectCompletedModal}
        onConfirm={handleCompleteConfirm}
        onCancel={handleCompleteCancel}
        isLoading={isLoadingCompletedProject}
      />

      <ProjectHoldToActiveModal
        show={showHoldToActiveModal}
        onConfirm={handleHoldToActiveConfirm}
        onCancel={handleHoldToActiveCancel}
        isLoading={holdToActiveLoading}
        project={
          projectList.find((p) => p.id === pendingHoldToActiveProjectId) || {}
        }
      />

      <Footer />
    </div>
  );
}

export default ProjectList;
